import chatModule from '@chat/module/store/type'
import auth from '@general/lib/auth';
import { conversationsFullyScrolled, scrollToLastMessage, beep } from '@chat/lib/helpers';
import _ from "lodash";

export default e => {
    let conversation = e.conversationData;
    let broadcasting = e.broadcastingData;

    let currentUserId = auth.getUserId();
    let message = conversation.message;
    let eventId = conversation.event.id;
    let chatType = conversation.chatType;

    if ((broadcasting.ignore_recipient_id || []).includes(currentUserId)) {
        return
    }

    console.log('[Group message listener] Signal received', e);

    // Remove cached chat images from memory
    if (message.msg_type === 'image') {
        store.commit(chatModule.mutations.messages.deleteImages, {
            eventId
        })
    } else if (message.msg_type === 'video') {
        store.commit(chatModule.mutations.messages.deleteVideos, {
            eventId
        })
    }
    let last_text_message = (['joined'].includes(message.msg_type) && message.user_from === auth.getUserId());

    // Update or unshift conversation
    if(!['joined', 'left'].includes(message.msg_type) || last_text_message
        ){
        let needed_conversation = conversation;
        if(last_text_message && !_.isEmpty(conversation.last_text_message)){
            needed_conversation = conversation.last_text_message;
        }
        store.dispatch(chatModule.actions.conversations.update, {
            eventId,
            conversation:needed_conversation,
            isNewUnreadMessage: !last_text_message,
            insertIfMissing: true
        })
    }

    // Push message
    store.commit(chatModule.mutations.message.push, {
        eventId,
        message
    });

    //add to unread conversations
    let conversation_key = chatType  + '_' + eventId;
    let unread_conversations = store.getters[chatModule.getters.general.unreadConversationsIds];
    const index = unread_conversations.indexOf(conversation_key);
    if (index === -1 && !['joined', 'left'].includes(message.msg_type)) {
        //unread_conversations.push(conversation_key)
        //store.commit(chatModule.mutations.general.setUnreadConversationsIds,unread_conversations)
    }
    if (
        (app.isMobile && app.$route.path === `/chat/group/${eventId}`)
        ||
        (
            app.isDesktop
            &&
            (store.state.chatModule.modal.event && store.state.chatModule.modal.event.id === eventId)
        )
    ) {
        store.dispatch(chatModule.actions.conversations.markAsRead, {
            eventId: eventId,
            chatType: conversation.chatType,
            userId:  currentUserId,
            sync:    true
        });
    }

    let mobilePaths = ['/chat', `/chat/event/${eventId}`];
    let chatDropdownHidden = $('#chat-dropdown').attr('aria-hidden') === 'true';
    let chatDropDownTabVisible = $('#b-chat__chat').is(':visible');
    let notChattingWithSender =
        !store.state.chatModule.modal.event
        ||
        store.state.chatModule.modal.event.id !== eventId;

    // Bottom bar notification icon
    if (
        !['joined', 'left'].includes(message.msg_type)
        &&
        (
            (app.isMobile && !mobilePaths.includes(app.$route.path))
            ||
            (app.isDesktop && (chatDropdownHidden || !chatDropDownTabVisible))
        )
        &&
        notChattingWithSender
    ){
        store.commit('updateUser', {has_new_messages: true})
    } else {
        // axios.post('/api/updateUser', {has_new_messages: false})
        // store.dispatch(chatModule.actions.conversations.markAsRead, {
        //     eventId: eventId,
        //     userId:  currentUserId,
        //     sync:    true
        // });
    }

    const wasAtBottom = conversationsFullyScrolled(conversation.chatType);
    if (wasAtBottom) {
        setTimeout(() => {
            scrollToLastMessage(conversation.chatType);
        }, 50)
    }

    if (['joined', 'left'].indexOf(conversation.message?.msg_type) === -1) {
        beep();

        console.log('[Group message listener] Beeped', conversation);
    } else {
        console.log('[Group message listener] Did not beep, incorrect type', conversation);
    }
}
